import CardCommon from '@op/components/CardCommon';
import { commonBarHIcon, lineIcon } from '@op/constants/chart';
import {
  RequestFuncMapType,
  useOverviewChannelOrLanguageInfo,
} from '@op/pages/Overview/KeyMetrics/hooks/channel';
import React, { useMemo, useState } from 'react';
import ChartProgress from './ChartProgress';
import LineChart from './LineChart';
import { expandableLeftChartHeight } from '@op/pages/Summary/constants';
import { useIntl } from 'umi';

export default function LanguageChannelChart({
  filter,
  type,
  translate = (text: string) => text,
  title,
  defaultChartType = 'common-bar',
}: {
  filter: any;
  type: RequestFuncMapType;
  translate?: any;
  title: string;
  defaultChartType?: 'common-bar' | 'line';
}) {
  const [chartType, setChartType] = useState<any>(defaultChartType);

  const { formatMessage } = useIntl();
  const params = useMemo(() => {
    return { ...filter, top_n: 5 };
  }, [filter]);

  const { loading, chartData, empty } = useOverviewChannelOrLanguageInfo({
    filter: params,
    type,
  });

  const { pie, timeline } = useMemo(() => {
    const { pie, timeline } = chartData || {};
    return {
      pie,
      timeline,
    };
  }, [chartData]);

  return (
    <div className="dbo-topic-analysis-chart">
      <CardCommon
        contentCard
        title={formatMessage({ id: title })}
        operations={[lineIcon, commonBarHIcon]}
        defaultOperation={chartType}
        loading={loading}
        empty={empty}
        hasEmptyImg={false}
        hasEmptyTitle={false}
        emptyHeight={expandableLeftChartHeight}
        loadingHeight={expandableLeftChartHeight}
        handleOperationsOnClick={(value) => setChartType(value.symbol)}
      >
        <>
          {chartType === 'common-bar' ? (
            <ChartProgress
              translate={translate}
              total={pie?.mentionsTotal}
              data={pie?.data}
            />
          ) : (
            <LineChart
              timeline={timeline}
              type={type}
              filter={filter}
              translate={translate}
            ></LineChart>
          )}
        </>
      </CardCommon>
    </div>
  );
}
